import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import {
  dateSchema,
  parseToDateValue,
  preprocessTextAsyncAutocompleteField,
} from "@/features/FormCard/utils";
import { z } from "zod";
import { DEFAULT_CATEGORY_OPTIONS } from "./config";
import i18n from "@/i18n";

const filterC8TransactionsSchema = z.object({
  c8_static_datum_name_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional(),
  category_contains: z.string().optional(),
  description_contains: z.string().optional(),
  fees_contains: z.string().optional(),
  tax_contains: z.string().optional(),
  quantity_contains: z.string().optional(),
  market_value_local_ccy_contains: z.string().optional(),
  market_value_ptf_ccy_contains: z.string().optional(),
  date_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  date_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  create_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  create_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
});

export type FilterC8TransactionsSchema = z.infer<
  typeof filterC8TransactionsSchema
>;

const fields: Field[] = [
  {
    name: "c8_static_datum_name_contains",
    label: `Actif`,
    type: "asyncAutocomplete",
    base_url: "c8/c8_static_data",
    column_name: "name",
    col_span: 2,
  },
  {
    name: "category_contains",
    label: `Type de mouvement`,
    type: "sectionSelect",
    useTranslation: true,
    translate_key: "category",
    client: "c8",
    table_name: "c8_transactions",
    language: i18n.resolvedLanguage?.startsWith("fr") ? "fr" : "en",
    options: DEFAULT_CATEGORY_OPTIONS,
  },
  {
    name: "description_contains",
    label: `Description`,
    type: "input",
  },
  {
    name: "date",
    type: "dateRange",
    label: "Date de valeur",
    from: { name: "date_from" },
    to: { name: "date_to" },
    col_span: 2,
  },
  {
    name: "create",
    type: "dateRange",
    label: "Date de création",
    from: { name: "create_from" },
    to: { name: "create_to" },
    col_span: 2,
  },
];

export function FilterC8Transactions() {
  return (
    <FilterTable
      columns={2}
      client="c8"
      schema={filterC8TransactionsSchema}
      tableName="c8_transactions"
      fields={fields}
    />
  );
}
